import React, { Component } from 'react'
import { connect } from 'react-redux'
import I18n from '../../i18n/i18n'
import LeftMenuScreen from '../Menu/LeftMenuScreen'
import Admin from '../../Components/Screens/Admin/Admin'
import AdminActions from '../../Redux/AdminRedux'
import styles from '../Styles/Screens'

class AdminScreen extends Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedOption: 'config'
    }
  }

  getOptions = () => {
    return [
      { key: 'config', label: I18n.t('screens.admin.options.config'), icon: 'settings' }
    ]
  }

  onSelectOption = (optionKey) => {
    this.setState({ selectedOption: optionKey })
  }

  onSubmitStripeKey = (secretKey) => {
    this.props.updateStripeKey(secretKey)
  }

  render = () => {
    return (
      <div style={styles.mainContainer}>
        <div style={styles.container}>
          <LeftMenuScreen />
          <Admin
            options={this.getOptions()}
            activeOption={this.state.selectedOption}
            onSelectOption={this.onSelectOption}
            fetching={this.props.fetching}
            onSubmitStripeKey={this.onSubmitStripeKey}
          />
        </div>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    fetching: state.admin.fetching,
    error: state.admin.error,
    success: state.admin.success
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateStripeKey: (secretKey) => dispatch(AdminActions.updateStripeKeyRequest(secretKey))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminScreen)
